import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

import { UrListPage } from '../ur-list/ur-list';
import { UrAddPage } from '../ur-add/ur-add'

import { GlobalsProvider } from '../../providers/globals/globals';

import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/timeout';
import { LoadingController } from 'ionic-angular';

@Component({
  selector: 'page-zapis',
  templateUrl: 'zapis.html',
})
export class ZapisPage {

  zitems: Array<{ id: string, name: string }>;
  item: any;
  form: FormGroup;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formbuilder: FormBuilder,
    public params: GlobalsProvider,
    public loadingCtrl: LoadingController,
    public http: Http
  ) {
    this.item = navParams.get('item');

    this.zitems = [
      { id: 'zupch', name: this.params.phrases[this.params.id_lang]['zapis-upch'] },
      { id: 'zurist', name: this.params.phrases[this.params.id_lang]['zapis-ur'] },
      { id: 'zmedik', name: this.params.phrases[this.params.id_lang]['zapis-med'] },
      { id: 'zsrab', name: this.params.phrases[this.params.id_lang]['zapis-sr'] }
    ];

    this.form = new FormGroup({
      name: new FormControl('', [Validators.required]),
      phone: new FormControl('', [Validators.required]),
      date: new FormControl('', [Validators.required])
    })
  }

  itemShow(item) {
    // That's right, we're pushing to ourselves!
    this.navCtrl.push(ZapisPage, {
      item: item
    });
  }

  sendData() {
    console.log(this.form.value);

    let loadingPopup = this.loadingCtrl.create({
      content: ''
    });

    let form_info: any;
    let postData = new FormData();

    form_info = this.form.value;

    for (var key in form_info) {
      postData.append(key, form_info[key]);
    }

    postData.append('text', 'Дата: ' + form_info['date'][8] + form_info['date'][9] + '.' + form_info['date'][5] + form_info['date'][6] + '.' + form_info['date'][0] + form_info['date'][1] + form_info['date'][2] + form_info['date'][3] + '<br/>Имя: ' + form_info['name'] + '<br/>Телефон: ' + form_info['phone']);

    loadingPopup.present();
    console.log(this.params.apiURL + '?act=zapis&id_user=' + this.params.id_user + '&type=' + this.item.id);
    this.http.post(this.params.apiURL + '?act=zapis&id_user=' + this.params.id_user+'&type='+this.item.id, postData)
      .timeout(20000)
      .map(res => res.json())
      .subscribe(
        data => {
          setTimeout(() => {
            console.log(data);

            loadingPopup.dismiss();
            this.navCtrl.push(UrListPage);
          }, 1000);

        },

        err => {
          console.log('error');
          loadingPopup.dismiss();
        }

      );
  }

  addQ() {
    this.navCtrl.push(UrAddPage);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ZapisPage');
  }

  ionViewWillEnter() {
    this.params.stat('zapis');    
  }     

}



// WEBPACK FOOTER //
// ./src/pages/zapis/zapis.ts